import type React from 'react';

import { Alert, Link, Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { useEmailVerificationModalBody } from './hooks/useEmailVerificationModalBody';

export const EmailVerificationModal: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { display, showContinueAsGuest, resendEmailResult, ariaLabel, title },
		actions: { resendVerificationEmail, closeModal },
	} = useEmailVerificationModalBody();

	if (!display) return null;

	return (
		<Modal
			isDismissable
			isOpen
			aria-label={ariaLabel}
			onClose={closeModal}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			onOpenChange={(open) => {
				if (!open) closeModal();
			}}
			className="z-999 [&_h2]:w-full [&_h2]:max-w-none! [&_h2]:justify-center"
			size="small"
		>
			<ModalHeader title={title} />
			<ModalBody>
				<div data-qa="verify-email-modal" className="w-full text-center">
					{resendEmailResult === 'success' && (
						<Alert variant="success" className="mb-4">
							<Translate value="fe.pages.sponsors.verify_email.verify_email_resent" />
						</Alert>
					)}
					{resendEmailResult === 'error' && (
						<Alert variant="error" className="mb-4">
							<Translate value="fe.errors.sponsors.send_verify_email" />
						</Alert>
					)}
					<Text as="div" className="text-typography-strong mt-4">
						<Translate value="fe.pages.sponsors.verify_email.require_verify" />
					</Text>
					<div className="bg-fill-weaker mt-6 mb-4 rounded-lg p-2.5">
						<Text as="div" className="text-typography-strong">
							<Translate value="fe.pages.sponsors.verify_email.check_verify" />{' '}
						</Text>
						<div className="w-full py-3">
							<Link as="button" bold onClick={resendVerificationEmail} variant="secondary">
								<Translate value="fe.pages.sponsors.verify_email.resend_email" />
							</Link>
						</div>
					</div>
					{showContinueAsGuest && (
						<div className="mt-10 mb-6">
							<Link as="button" onClick={() => closeModal()}>
								<Translate value="fe.pages.sponsors.guest_login" />
							</Link>
						</div>
					)}
				</div>
			</ModalBody>
		</Modal>
	);
};
